export default __webpack_public_path__ + "static/media/1930.589724c1.png";